<template>  
  <div class="auth-bar-wrapper" :class="{'is-splash-parent': isSplash}">
    <div id="authBarPlaceholder" :class="{'is-transparent' : isTransparent,
                                            'is-splash': isSplash, 
                                            'is-special-mode': isSpecialMode}"  v-if="isLoggedIn">

      <div class="ab_auth-bar">
        <a class="ab_auth-bar__logo" href="/" style="background-image:url('')"></a>
        <div id="ab_auth-bar__auth-button-placeholder" data-is="auth-button">
            <div class="ab_auth-button">
                <div>
                    <div>
                        <div class="ab_user-button ab_clickable" @click="showUserProfile = !showUserProfile"> <img src="https://auth-lib.labs.refinitiv.com/assets/avatar.svg" class="ab_user-button__image">
                            <div class="ab_user-button__name"> {{ userName }} </div> <span class="ab_user-button__arrow"></span> </div>
                        <div v-if="showUserProfile">
                            <div class="ab_details-popover" id="ab_details-popover">
                                <div class="ab_details-popover__arrow"></div>
                                <div class="ab_details-popover__body">
                                    <div class="ab_details-popover__content">
                                        <div class="ab_details-popover__text ab_details-popover__text--large">{{ userName }}</div>
                                        <div class="ab_details-popover__text ab_details-popover__text--strong">{{ user }}</div>
                                        <div class="ab_details-popover__row"> <img class="ab_details-popover__logo" style="background-color: #001EFF" src="https://auth-lib.labs.refinitiv.com/assets/lseg_avatar.svg">
                                            <div>
                                                <div class="ab_details-popover__text">Signed in with</div>
                                                <div class="ab_details-popover__text ab_details-popover__text--strong">Refinitiv</div>
                                            </div> <a class="ab_button ab_button--sign-out" @click="handleSignOut">Sign Out</a> </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                    </div>
                  </div>
            </div>
        </div>
      </div>
    </div>

    <div class="logo-container" @click="goToHome()">
      <img src="../assets/logo_new.png" alt="Refinitiv Labs" v-if="!isSplash"/>
      <img src="../assets/logo_new.png" alt="Refinitiv Labs" v-if="isSplash"/>
      <div class="logo-line" v-if="!isSplash"></div>
      <span class="logo-text" v-if="!isSplash">
        Trade Discovery <div class="logo-superscript" v-if=" environment === 'preprod' ">Beta</div>
      </span>
    </div>

    <div class="maintenance-message" v-if="showMaintenance">
      <p>Application Scheduled Maintenance</p>
      <p>All Days – 20:00 to 22:00 HRS UTC &amp; Saturday:  08:00 to 22:00 HRS UTC. Contact Email: <a href="mailto:frtb-cloud-app-dev@lseg.com">frtb-cloud-app-dev@lseg.com</a></p>
    </div>

  <!-- RIGHT HAND NAVIGATION -->
    <i class="header-burger-icon material-icons" @click="menuIsExpanded = !menuIsExpanded" v-if="showNav">menu</i>
    <nav class="nav-header"
      :class="{'is-active': menuIsExpanded, 'signed-out': !user || routeName === 'splash'}"
    >
      <div v-if="showNav">
        <router-link to="/calculator"
          :class="{ 'router-link-active' : $route.path === '/results'}"
        >
          Risk Factor Calculator
        </router-link>
        <!--
        <button class="button"  @click.stop.prevent="openFeedback()">
          Feedback
        </button>
        -->
      </div>
    </nav>
  </div>
</template>

<script lang="ts">

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Env from '@/services/env.service';
import GAService from '@/services/ga.service';
import api from "../api/newget"
// declare var AuthBar: any;
@Component({
  components: {
  },
})
export default class Auth extends Vue {

  public menuIsExpanded: boolean = false;
  public routeName: string = '';
  public hideNavFor: string[] = [
    'splash'
  ];

  public showUserProfile: boolean = false;

  get environment() {
    return Env.get('VUE_APP_ENVIRONMENT');
  }

  get showNav() {
    return this.routeName && this.hideNavFor.indexOf(this.routeName) === -1;
  }
  
  get isTransparent() {
    return !this.authToken;
  }

  get authToken() {
    return this.$store.state.auth.authToken;
  }

  get tokenExp() {
    return this.$store.state.auth.tokenExp;
  }

  get isSplash() {
    return this.$route.name === 'splash';
  }

  get isLoggedIn() {
    return this.$store.state.auth.isAuthed;
  }

  get showMaintenance(){
    return this.routeName === 'calculator';
  }

  get isSpecialMode() {
    return Env.get("VUE_APP_NAMESPACE") ? true : false;
  }

  get user() {
    return this.$store.state.auth.user;
  }

  get userName() {
    return this.$store.state.auth.userGivenName + ' ' + this.$store.state.auth.userFamilyName;
  }

  public goToHome() {
    this.$router.push('/info')
  }

  @Watch('$route')
  public onPropertyChanged(value: string, oldValue: string) {
    this.menuIsExpanded = false;
    this.routeName = this.$route.name || '';
  }

  public openFeedback() {
    this.$store.commit('setModal', 'feedback');
  }

  public openAdminModal() {
    this.$store.commit('setModal', 'adminModal');
  }
  
  /**
   * Sets token and token expiry we've got from auth bar.
   * NB: doesn't redirect to eg '/', because this is called every
   * time the auth bar is initialised, ie even if a logged in user
   * refreshes the page. Route handling from logged out -> logged 
   * in is handled in individual views, eg Splash.vue
   */
  private onLogin(tokens: any[]) {
    const siteTokens = tokens.find((t: any) => t.dst === Env.get('VUE_APP_ISSUER'));
    this.$store.dispatch('onLogin', {
      token: siteTokens.token,
      exp: siteTokens.exp || 0
    });

    GAService.setDimension(this.$gtag, 'user_id', siteTokens.sub);

    this.listenForFocus();
  }

  private async onLogout() {
    try{
      const res = await api.get("/logout");
      if (res && res.status === 200) {
        console.log("Logout successful");
        this.$store.dispatch('onLogout');
      } else {
        console.error("Logout failed", res.data.message);
      }
    }catch(e){
      console.error("Error while calling logout API on logout", e);
    }
  }

  private addAuthBar() {
    // AuthBar.render(
    //   {
    //     identServiceUrl: Env.get('VUE_APP_IDENTITY_SERVICE'),
    //     issuer: Env.get('VUE_APP_ISSUER'),
    //     services: [Env.get('VUE_APP_ISSUER')],
    //     providers: ['safe', 'aaa'],
    //     redirectOnLogout: true,
    //     logoImageUrl: '',
    //     logoUrl: '/'
    //   },
    //   '#authBarPlaceholder'
    // );
    // AuthBar.on('login', (tokens: any[]) => {
    //   this.onLogin(tokens);
    // });
    // AuthBar.on('logout', () => {
    //   this.onLogout();
    // });
    // AuthBar.on('expired', (token: any) => {
    //   this.$store.dispatch('onLogout', true);
    // });


  }

  /** 
   * We need the following because...
   * To catch expired tokens, the authlib code has a timeout based on the 
   * token expiry time. On completion of this timeout, the expired event is
   * fired. We do listen for this (see above .on("expired")), but in Chrome inactive tabs
   * kill long running timeouts/intervals. We therefore also want to check
   * for token expiry whenever the page is re-focussed.
   */
  private listenForFocus() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && this.tokenExp) {
        if (Date.now() > (this.tokenExp * 1000)) {
          this.$store.dispatch('onLogout', true);
        }
      }
    });
  }

  private mounted() {
    this.routeName = this.$route.name || '';
    this.addAuthBar();

    const exp: number = localStorage.getItem('tokenExp') ? parseInt(localStorage.getItem('tokenExp') || '0', 10) : 0;
    if (exp && (Date.now() >= (exp * 1000))) {
      this.$store.dispatch('onLogout', true);
    }
  }

  public handleSignOut() {
    this.onLogout();
    this.showUserProfile = false;
  }
}

</script>

<style lang="scss">
@import '@/scss/partials/_settings.colors.scss';

.auth-bar-wrapper {
  height: 50px;
  position: relative;

  .maintenance-message{
      color: #020202;
      font-size: 12px;
      //padding-right: 40px;
      padding-right: 20px;
      //margin: 0 auto;
       position: absolute;
      top: 10px;
      left: calc(50% - 300px);
      max-width: 50%;
      z-index: 10;
      display: block;
      min-height: 1px;
      height: 11px;
  }
  .logo-container {
    position: fixed;
    top: 18px;
    left: 20px;
    min-width: 107px;
    z-index: 10;
    display: flex;
    min-height: 1px;
    height: 11px;

    img {
      height: 11px;
    }

    .logo-line {
      border-left: 2px solid rgba(0,0,0,.6);
      margin: 0 6px;
      height: 11px;
    }

    span.logo-text {
      white-space: nowrap;
      text-transform: uppercase;
      font-weight: 800;
      font-size: 14px;
      position: relative;
      top: -4px;

      .logo-superscript {
        position: absolute;
        top: 2px;
        font-size: 10px;
        font-weight: 800;
        left: calc(100% + 2px);
      }
    }

    &:hover {
      cursor: pointer;
      opacity: .7;
    }
  }

  &.is-splash-parent {
    height: 0;
  }


  #authBarPlaceholder {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;

    .ab_auth-bar {
      height: 50px;
      padding: 0 22px;
      background-color: #fff;
      border-bottom: 1px solid $grey-220;

      .ab_auth-bar__logo {
        height: 16px;

        &:hover {
          opacity: .8;
        }
      }
      .ab_signin-button {
        border: 1px solid #fff;
        border-radius: 4px;
        background-color: transparent;
        text-transform: capitalize;
        margin-left: 10px;
        font-size: 15px;
        height: 36px;
        line-height: 34px;
        padding-top: 0;
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 0;
        font-weight: 600;
        position: relative;
        transition: color 250ms ease;
        z-index: 1;
        overflow: hidden;

        &::after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            transform: translateY(100%);
            transition: transform 250ms ease;
            z-index: -1;
        }

        &:hover,
        &:focus {
            color: #323232;
            &::after {
                transform: translateY(0)
            }
        }
      }
    }

    &.is-transparent {
      .ab_auth-bar {
        background-color: transparent;
      }
    }

    &.is-special-mode {
      .ab_auth-bar {
        background-color: yellow;
      }
    }

    &.is-splash {
      .ab_auth-bar {
        border-bottom: 0;

        .ab_signin-button {
          display: none;
        }
      }
    }
  }

  .header-burger-icon {
    display: none;
    position: fixed;
    top: 0;
    right: 70px;
    height: 50px;
    color: #fff;
    line-height: 50px;
    font-size: 24px;
    z-index: 5;

    &:hover, &:active {
      cursor: pointer;
      opacity: .8;
    }
  }

  .nav-header {
    position: fixed;
    right: 104px;
    top: 0;
    z-index: 10;
    color: #333;

    &.signed-out {
      // right: 24px;
    }

    #requestInvitation {
      text-decoration: underline;
    }

    .button {
      font-weight: 500;
      margin-top: 10px;
      margin-left: 18px;
    }

    a {
      color: #333;
      padding: 0 24px;
      line-height: 50px;
      font-weight: 500;
      display: inline-block;
      position: relative;
      transition: color 150ms ease;

      i {
        position: relative;
        top: 4px;
        margin-left: 1px;
        font-size: 20px;
      }

      &.router-link-active:after {
        content: "";
        width: 100%;
        height: 4px;
        background-color: $refinitiv-blue;
        position: absolute;
        bottom: 0;
        left: 0;
      }

      &:hover, &:focus {
        color: $refinitiv-blue;
        opacity: .6;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .header-burger-icon {
      display: block;
    }

    .nav-header {
      top: 67px;
      left: 0;
      right: 0;
      background-color: $refinitiv-blue;
      z-index: 110;
      display: flex;
      flex-direction: column;
      height: auto;
      padding: 0;
      max-height: 0;
      overflow: hidden;
      transition: max-height 250ms ease;

      &.is-active {
        max-height: 240px;
      }

      a {
        padding: 18px 24px;
        display: block;
        height: 54px;
        line-height: 1.15em;
        width: 100%;
        text-align: center;

        &.router-link-active {
          opacity: .6;
          &:after {
            height: 0px;
          }
        }

        span {
          padding: 0;
          display: inline-block;
        }

        &:first-child {
          margin-top: 12px
        }
        &:last-child {
          margin-bottom: 12px
        }
      }

      a.is-active span::after {
        display: none;
      }
    }
  }
}
@media only screen and (min-width: 992px) {
  .auth-bar-wrapper .logo-container span.logo-text{
    top : 1px;
  }
  .auth-bar-wrapper .logo-container .logo-line{
    margin-top : 7px;
  }
  .auth-bar-wrapper .logo-container img{
    height : 22px;
  }
}
</style>

